import { Button, TableCell, TableRow } from '@mui/material';
import { format } from 'date-fns';
import { useHistory, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';

import { type LTICredential } from '../../../../types/apiTypes';
import getTimeFormatFromLocale from '../../../../utils/getTimeFormatFromLocale';

interface IntegrationTableRowProps {
    data: LTICredential;
}

const StyledTableRow = styled(TableRow)``;

const StyledTableCell = styled(TableCell)`
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
`;

const { format: timeFormat } = getTimeFormatFromLocale();

const IntegrationTableRow: React.FC<IntegrationTableRowProps> = ({ data }) => {
    const { title, type, updated_at: updatedAt, lti_version: ltiVersion } = data;
    const lastUpdated = format(new Date(updatedAt), timeFormat);
    const history = useHistory();
    const { path } = useRouteMatch();
    const handleClick = () => {
        history.push(`${path}/edit/${data.lti_creds_uuid}`);
    };

    return (
        <StyledTableRow>
            <StyledTableCell>
                <Button onClick={handleClick}>{title}</Button>
            </StyledTableCell>
            <StyledTableCell>{ltiVersion}</StyledTableCell>
            <StyledTableCell>{type}</StyledTableCell>
            <StyledTableCell>{lastUpdated}</StyledTableCell>
        </StyledTableRow>
    );
};

export default IntegrationTableRow;
